export const Step3Langague = {
  nationality: {
    th: "สัญชาติ",
    en: "Nationality",
  },
  identity: {
    th: "หมายเลขบัตรประชาชน",
    en: "ID Card No.",
  },
  other_identity: {
    th: "เลขที่หนังสือเดินทาง",
    en: "Passport No.",
  },
  identityPlaceHolder: {
    th: "หมายเลขบัตร",
    en: "ID Card",
  },
  other_identityPlaceHolder: {
    th: "เลขที่หนังสือ",
    en: "Passport No.",
  },
  expiredDate: {
    th: "วันหมดอายุบัตร",
    en: "Expiry date",
  },
  fullnameEng: {
    th: "ชื่อ/นามสกุล (อังกฤษ)",
    en: "Name / Lastname (English)",
  },
  fullnameEngVisa: {
    th: "ชื่อ/นามสกุล (อังกฤษ)",
    en: "Name/SurName (Eng)",
  },
  initName: {
    th: "คำนำหน้าชื่อ",
    en: "Prefix",
  },
  firstName: {
    th: "ชื่อ",
    en: "FIRST NAME",
  },
  lastName: {
    th: "นามสกุล",
    en: "LAST NAME",
  },
  birthdate: {
    th: "วันเกิด",
    en: "Birthdate",
  },
  gender: {
    th: "เพศ",
    en: "Gender",
  },
  male: {
    th: "ชาย",
    en: "Male",
  },
  female: {
    th: "หญิง",
    en: "Female",
  },
  ocupation: {
    th: "อาชีพ (ถ้ามีโปรดระบุ)",
    en: "Ocupation (optional)",
  },
  ocupationPlaceHolder: {
    th: "อาชีพ",
    en: "Ocupation",
  },
  contact: {
    th: "เบอร์ติดต่อกลับ",
    en: "Contact no.",
  },
  contactPlaceHolder: {
    th: "เบอร์โทรศัพท์",
    en: "Telephone number",
  },
  email: {
    th: "อีเมล",
    en: "E-mail",
  },
  //Address Form
  no: {
    th: "เลขที่",
    en: "No.",
  },
  moo: {
    th: "หมู่",
    en: "Moo",
  },
  soi: {
    th: "ซอย",
    en: "Soi",
  },
  road: {
    th: "ถนน",
    en: "Road",
  },
  province: {
    th: "จังหวัด",
    en: "Province",
  },
  district: {
    th: "เขต/อำเภอ",
    en: "District / Amphur",
  },
  subDistrict: {
    th: "แขวง/ตำบล",
    en: "Sub-district / Tumbon",
  },
  postCode: {
    th: "รหัสไปรษณีย์",
    en: "Post Code",
  },
  // Addition
  year: {
    th: "ปี",
    en: "Years",
  },
  address: {
    th: "ที่อยู่ผู้เอาประกัน",
    en: "Address shows on a policy",
  },
  benefitHeader: {
    th: "ผู้รับประโยชน์",
    en: "Beneficiary",
  },
  pleaseChoose: {
    th: "โปรดเลือก",
    en: "please select",
  },
  pleaseChooseUpper: {
    th: "โปรดเลือก",
    en: "Please Select",
  },
  office: {
    th: "ชื่อบริษัท",
    en: "Organize name",
  },
  benefit: {
    th: "ทายาทโดยธรรม",
    en: "Statutory Heir",
  },
  otherBenefit: {
    th: "ระบุผู้รับประโยชน์",
    en: "Specify the beneficiary",
  },
  benefitPlaceholder: {
    th: "ชื่อ/นามสกุล",
    en: "Name/Lastname",
  },
  relation: {
    th: "ความสัมพันธ์",
    en: "Relationship",
  },
  addBeneficiary: {
    th: "เพิ่มผู้รับประโยชน์",
    en: "Add Beneficiary",
  },
  removeBeneficiary: {
    th: "ลบผู้รับประโยชน์",
    en: "Remove Beneficiary",
  },
  assuranceFor: {
    th: "แผนประกันภัยอุบัติเหตุสำหรับ",
    en: "This personal assurance is for"
  },
  insurancePeriod: {
    th: "ระยะเวลาเอาประกัน",
    en: "Period of Insurance"
  },
  forSelf: {
    th: "ตนเอง",
    en: "My Self"
  },
  otherPeople: {
    th: "บุคคลอื่น",
    en: "Others"
  },
  buildingVillage: {
    th: "หมู่บ้าน / อาคาร",
    en: "Village / Building",
  },
};

export const HEALTH_CHECK = [
  {
    value: "CHECK1",
    label:
      "คุณมีประกันภัยอุบัติเหตุส่วนบุคคลหรือประกันชีวิตไว้กับบริษัทเมืองไทยประกันภัย และ/หรือ บริษัทอื่น",
  },
  {
    value: "CHECK2",
    label:
      "คุณเคยถูกปฏิเสธการขอเอาประกันชีวิต, การขอเอาประกันภัยอุบัติเหตุส่วนบุคคลหรือ, การต่ออายุสัญญา หรือถูกเรียกเก็บเบี้ยประกันเพิ่มสำหรับการประกันภัยดังกล่าว",
  },
  {
    value: "CHECK3",
    label:
      "คุณเคยใช้สารเสพติดให้โทษ หรือดื่มที่มีแอลกอฮอล์เป็นประจำ หรือเคยได้รับการรักษาเกี่ยวกับโรคดังกล่าว",
  },
  {
    value: "CHECK4",
    label:
      "โรคลมชัก, โรคหัวใจ, โรคความดันโลหิตสูง, โรคเบาหวาน, โรคกระดูกและ / หรือกล้ามเนื้อ, โรคมะเร็ง, โรคเอดส์",
  },
  {
    value: "CHECK5",
    label:
      "อวัยวะพิการ, ความสามารถในการมองเห็น, ความสามารถในการได้ยิน, ความผิดปกติของร่างกายที่ได้รับผลกระทบจากอุบัติเหตุ",
  },
];
